import * as types from '../constants/ActionTypes';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_CONFIG:
      return { ...state, ...action.config };

    case types.ADD_TOKEN:
      return { ...state, ...action.token };

    case types.CHANGE_ANONYM:
      return { ...state, WITH_PATIENT_DISCLOSED: !state.WITH_PATIENT_DISCLOSED };

    default:
      return state;
  }
};
